export function removeCls (selector, cls) {
  const $el = $(selector)
  if (isClassDefined($el, cls)) {
    $el.removeClass(cls)
  }
}

export function addCls (selector, cls) {
  const $el = $(selector)
  if (!isClassDefined($el, cls)) {
    $el.addClass(cls)
  }
}

function isClassDefined ($el, cls) {
  return $el.length && $el.hasClass(cls)
}
